import { Box, styled } from "@mui/material";

export const HeadingText = styled("span")(({ theme }) => ({
    color: 'black',
    fontSize: "12px"
}));

export const ValueText = styled("span")(({ theme }) => ({
    color: 'black',
    fontWeight: 'bold',
    fontSize: "12px"
}));
export const FlexBox = styled(Box)(({ theme }) => ({
    display: "flex",
    gap:4
}));

export const checkoutSX = {
  page: {
    minHeight: "100vh",
  },
  gridRightColumn: {
    display: 'flex',
    flexDirection: 'column',
    mt: { xs: 2, sm: 0 }
  },
  hrBox: {
    width: "100%",
    display: { xs: 'block', sm: 'none' },
  },
  wrapper: {
    pb: 6,
    py: 3,
    display: "flex",
    flexDirection: { xs: "column", lg: "column" },
    width: "100%",
  },
  center: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  content: {
    width: { xs: "100%", md: "73%" },
    display: "flex",
    flexDirection: "column",
    gap: 5,
    px: { xs: 2, md: 5 },
  },
  headerRow: {
    display: "flex",
    gap: 2,
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "space-between",
  },
  courseInfo: {
    display: "flex",
    alignItems: { md: "flex-end" },
    gap: 2,
  },
  courseImageBox: {
    height: "50px",
    width: "70px",
    borderTop: "1px solid #ccc",
    borderBottom: "1px solid #ccc",
    borderRadius: "10px",
    overflow: "hidden",
    position: "relative",
    cursor: "pointer",
  },
  courseTitle: {
    fontSize: { xs: "16px", sm: "22px" },
    textAlign: "center",
    textTransform: "capitalize",
  },
  educatorBox: {
    display: "flex",
    gap: 1,
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  educatorName: {
    fontSize: "16px",
    textTransform: "capitalize",
    minWidth: { md: "100px" },
  },
  avatar: {
    cursor: "pointer",
  },
  scheduleGrid: {
    borderRadius: "30px",
    p: 3,
  },
  skeletonRect: {
    width: "100%",
    height: "100%"
  },
  dividerBox: {
    width: "100%",
    display: { xs: "block", sm: "none" },
  },
  bottomSection: {
    width: "100%",
    px: { xs: 2, md: 5 },
  },
  errorBox: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
}